/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */
import Framework, { BaseService } from '@greenville/framework';
import _ from 'lodash';
import * as constants from '../../../../common/constants';
import utils from '../../../../common/utils';
import { normalizeTelemetryDetailResponse } from '../utils/telemetryUtils';

export default class TelemetryDetailService extends BaseService {
  constructor() {
    super(constants.GET_TELEMETRY_DETAIL, constants.TELEMETRY_DETAIL_STATUS);
  }

  async handleEvent(eventName, event) {
    const headers = {
      'x-berlin-tenant-id': event.payload.tenantId
    };
    const { traceId } = event.payload;
    let payload = _.omit(event.payload, ['traceId']);
    payload = _.omit(payload, ['tenantId']);
    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackb').post(`${constants.TELEMETRY_SEARCH_ENDPOINT}/${traceId}`, payload, {
        headers: enhancedHeaders
      });
    }
    return this.getClient('aiadmin').post(`${constants.TELEMETRY_SEARCH_ENDPOINT}/${traceId}`, payload, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    const body = data ?? response;
    const normalized = normalizeTelemetryDetailResponse(body);
    Framework.getStoreRegistry().getStore('telemetryDetail').setResponse(normalized);
  }

  handleError(error) {
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        Framework.getStoreRegistry().getStore('notificationState').set({
          open: true,
          message: data.error.message,
          type: 'error'
        });
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      Framework.getStoreRegistry().getStore('notificationState').set({
        open: true,
        message: error.message,
        type: 'error'
      });
    }
    Framework.getStoreRegistry().getStore('telemetryDetail').resetStoreValues();
  }
}
